'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('template-list', {
      url: '/template/list',
      template: '<template-list></template-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/template/template-list/template-list.routes.js